<template>
  <g>
    <rect y="6" width="11" height="11" rx="5.5" fill="#0D94FD" />
    <rect x="13" y="6" width="11" height="11" rx="5.5" fill="#0D94FD" />
    <rect x="7" y="6" width="11" height="11" rx="5.5" fill="#013F6F" />
  </g>
</template>
